export default __webpack_public_path__ + "static/media/metodologiaPNG.2bc38b50.png";